import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as AnalyticsActions from '../actions/analytics.actions';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { AnalyticsNextService } from '../../core/analytics-next/analytics-next';
import { Store } from "@ngrx/store";
import { selectPageHeaderTitle } from "../selectors";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class AnalyticsEffects {

  constructor(
    private actions$: Actions,
    private analytics: AnalyticsNextService
  ) {
  }

  trackItem$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AnalyticsActions.trackItem),
      tap(({ label, data }) => {
        this.analytics.track(label, data);
      })
    )
  }, { dispatch: false });

  trackDashboard$ = createEffect((translateService = inject(TranslateService), store = inject(Store)) => {
    return this.actions$.pipe(
      ofType(AnalyticsActions.trackDashboard),
      switchMap((action) => store.select(selectPageHeaderTitle).pipe(
          map((title) => ({
              label: action.label, data: {
                ...action.data,
                title: translateService.instant(`${ title }.title`) ?? action.data.title
              }
            })
          ),
          map((data) => AnalyticsActions.trackItem(data))
        )
      ),
    )
  });

  trackPage$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AnalyticsActions.trackPage),
      filter(({ data }) => !!data?.name),
      tap(({ data }) => {
        this.analytics.page(data);
      })
    )
  }, { dispatch: false });

}
